import { render, staticRenderFns } from "./TextOverlayStage.vue?vue&type=template&id=017b041c&"
import script from "./TextOverlayStage.vue?vue&type=script&lang=js&"
export * from "./TextOverlayStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports